import React from 'react'
import Instructor from "../../../assets/Images/Instructor.png"
import HighlightText from './HighlightText'
import { FiArrowDown, FiArrowRight } from 'react-icons/fi'
import CTAButton from "./Button"

export const InstructorSection = () => {
    return (
        <div className='mt-16 '>
            <div className=' flex sm:flex-row flex-col gap-20 items-center '>

                <div className='w-[50%] '>
                    <img className='maindiv border-l-[25px]  border-b-[25px]' src={Instructor} alt="" />

                </div>

                <div className='w-[50%] flex flex-col gap-10 '>

                    <div className='text-4xl font-semibold w-[50%]'>
                        Become an
                        <HighlightText text={"Instructor"} />
                    </div>

                    <p className=' w-[80%] font-medium text-[16px]  text-richblack-300'>

                        Instructors from around the world teach millions of students on StudyNotion. We provide the tools
                        and skills to teach what you love.
                    </p>

                    <div className='w-fit'>
                    <CTAButton active={true} linkto={"/signup"}>
                        <div className='flex flex-row gap-2 items-center'>
                            Start Learning Today
                            <FiArrowRight/>
                        </div>
                    </CTAButton>
                    </div>

            

                </div>

            </div>
        </div>
    )
}
